import styled from 'styled-components';
import { useState } from 'react';

import { ConditionalWrapper } from 'shared/components/ConditionalWrapper';
import { Video } from 'shared/components/Video';
import { ZoomedInDraggableRobotWrapper } from 'productTemplate/components/robotGallery/ZoomedInDraggableRobotWrapper';

interface IRobotVideoExpandedView {
  handleOnClick: () => void;
  isZoomedIn: boolean;
  movUrl: string;
  posterImg: string;
  webmUrl: string;
  expandedCount: number;
}

export const RobotVideoExpandedView = ({
  handleOnClick,
  isZoomedIn,
  movUrl,
  posterImg,
  webmUrl,
  expandedCount,
}: IRobotVideoExpandedView) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleRobotClick = () => {
    if (handleOnClick && !isDragging) {
      handleOnClick();
    }
  };

  return (
    <ConditionalWrapper
      if={isZoomedIn}
      with={(_children) => (
        <ZoomedInDraggableRobotWrapper setIsDragging={setIsDragging}>
          {_children}
        </ZoomedInDraggableRobotWrapper>
      )}
    >
      <RobotVideoExpandedView.Video
        $isZoomedIn={isZoomedIn}
        $imageCount={expandedCount}
        onClick={handleRobotClick}
        movUrl={movUrl}
        poster={posterImg}
        webmUrl={webmUrl}
      />
    </ConditionalWrapper>
  );
};

RobotVideoExpandedView.Video = styled(Video)<{
  $isZoomedIn: boolean;
  $imageCount: number;
}>`
  height: min(calc(100vh - 166px), 750px);
  margin: 0px 6px;
  max-width: ${({ $imageCount }) => `calc(100% / ${$imageCount});`}
  cursor: pointer;
  object-fit: cover;


  ${({ $isZoomedIn, theme }) =>
    $isZoomedIn &&
    `
      transform: scale(2);
      z-index: ${theme.zIndex.zoomedInRobot};
      cursor: grab;
      max-width: 100% !important;

      &:active {
        cursor: grabbing;
      }
  `}
`;
